class TimelineBands extends React.Component {
  componentDidMount() {
    this.updateChart(this.props, this.state);
  }

  shouldComponentUpdate(nextProps, nextState) {
    this.updateChart(nextProps, nextState);

    return true;
  }

  updateChart(props, state) {
    let { data, scale, height } = props;
    let rootNode = d3.select(ReactDOM.findDOMNode(this));
    let dataNode = rootNode.select(".rc-timeline-bands-data");

    // join adjacent 1-minute blocks of same color
    let joined = data.map(function (d, i) {
      return { ...d, idx: i };
    }).filter(function (d, i, a) {
      return i === 0 || d.color !== a[i - 1].color;
    }).map(function (d, i, a) {
      let j = a.length - 1;
      let k = data.length - 1;
      let n = a[i + 1] ? a[i + 1].ts : null;

      return {
        start: d.ts,
        stop: i === j ? ((d.idx === k ? d.ts : data[k].ts) + 60000) : n,
        label: d.label,
        color: d.color
      };
    });

    let rects = dataNode.selectAll("rect").data(joined, function (d, i) {
      return d.start;
    });

    rects
      .exit()
      .remove();

    rects = rects
      .enter()
      .append("rect")
      .merge(rects);

    rects
      .attr("x", function (d, i) {
        return scale(d.start);
      })
      .attr("width", function (d, i) {
        return scale(d.stop) - scale(d.start);
      })
      .attr("height", height)
      .attr("fill", function (d, i) {
        return d.color;
      })
      .attr("data-tooltip", function (d, i) {
        return d.label;
      });
  }

  render() {
    let { width, height } = this.props;

    return (
      <g className="rc-timeline-bands">
        <rect x="0" y="0" width={width} height={height}/>
        <g className="rc-timeline-bands-data"/>
      </g>
    );
  }
}

TimelineBands.defaultProps = {
  height: 60
};

module.exports = TimelineBands;